import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { InputSize } from '../../utils/types';
import { Color as PColor } from '../../utils/types/palette';
import { sizeHintMixin } from './form-hint.mixin';
var baseClassName = 'FormHint';
var FormHint = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-1vu99sv-0"
})(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? InputSize.Md : _ref$size,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    theme = _ref.theme;
  return css(["display:flex;align-items:center;color:", ";", " ", ""], error ? theme.palette[PColor.Error] : theme.palette[PColor.TextSecondary], disabled && css(["color:", ";"], theme.palette[PColor.ButtonDisabledText]), sizeHintMixin[size]);
});
var Styled = applyDisplayNames({
  FormHint: FormHint
});
export default Styled;